/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import classnames from 'classnames';
import * as React from 'react';

import { Button } from '..';
import { Modal, ModalBody, ModalHeader } from '../modal';

export interface IPopupProductsProps {
    dialogStrings?: {
        closeWindowButtonText: string;
    };

    className: string;
    processStatusClass: string;
    text: string;

    modalOpen: boolean | undefined;
    setModalOpen(newValue: boolean): void;
}

export const PopupProducts = (popupProps: IPopupProductsProps) => {
    const { processStatusClass, dialogStrings, className, text, modalOpen, setModalOpen } = popupProps;
    if (!dialogStrings || !text) {
        return null;
    }

    const closeModal = () => {
        setModalOpen(false);
    };

    return (
        <Modal
            toggle={closeModal} isOpen={modalOpen} onClosed={closeModal}
            className={`${className}__dialog`}>
            <ModalHeader toggle={closeModal} className={`${className}__dialog__header`} />
            <ModalBody className={classnames(`${className}__dialog__body`, `${className}__dialog__body__${processStatusClass}`)}>
                <div className={`${className}__dialog__image`} />
                <div className={`${className}__dialog__process-status`}>
                    {text}
                </div>
                <Button className={`${className}__dialog__back-to-order-template`} onClick={closeModal} title={dialogStrings.closeWindowButtonText}>
                    {dialogStrings.closeWindowButtonText}
                </Button>
            </ModalBody>
        </Modal>
    );
};

export default PopupProducts;
